<!--  -->
<template>
  <a-layout-header
    class="header"
    :style="!collapsed ? 'width: calc(100% - 250px)' : 'width: calc(100% - 80px)'"
  >
    <div class="header-dd">
      <div class="header-line">
        <div>
          <menu-unfold-outlined v-if="collapsed" class="trigger" @click="toggleCollapsed" />
          <menu-fold-outlined v-else class="trigger" @click="toggleCollapsed" />
        </div>
        <div class="breadcrumb">
          <a-breadcrumb>
            <a-breadcrumb-item v-for="(item,index) in breadList" :key="index">
              <router-link :to="{path:item.path}" v-if="item.path === '/event/list/data'">
                <template v-if="route.query.type == '1'">投票数据查询</template>
                <template v-if="route.query.type == '4'">邀请好友数据查询</template>
                <template v-if="route.query.type == '3'">答题数据查询</template>
                <template v-if="route.query.type == '2'">抽奖数据查询</template>
              </router-link>
              <router-link :to="{path:item.path}" v-else>{{item.meta.title}}</router-link>
            </a-breadcrumb-item>
          </a-breadcrumb>
        </div>
      </div>
      <Avatar :avatar="'https://i.gtimg.cn/club/item/face/img/2/15922_100.gif'" />
    </div>
  </a-layout-header>
</template>

<script>
// 导入的其他文件 例如：import moduleName from 'modulePath';
import { defineComponent, ref, watchEffect } from "vue";
import { MenuUnfoldOutlined, MenuFoldOutlined } from "@ant-design/icons-vue";
import Avatar from "../avatar";
import { useRouter, useRoute } from "vue-router";

export default defineComponent({
  components: {
    MenuUnfoldOutlined,
    MenuFoldOutlined,
    Avatar
  },
  props: {
    collapsed: Boolean
  },
  setup(props, { emit }) {
    const route = useRoute();
    const toggleCollapsed = () => {
      emit("toggle-collapsed");
    };
    const { currentRoute } = useRouter();
    const breadList = ref([]);

    watchEffect(() => {
      let matched = currentRoute.value.matched;
      console.log(matched, "matched");
      //  处理三级
      if (route.name === "listItem" || route.name === "gameList") {
        matched = matched.filter((item, index) => index !== 2);
      }
      if (!matched || matched.length === 0) return;
      if (matched[0].path != "/") {
        breadList.value = [{ path: "/", meta: { title: "首页" } }].concat(
          matched
        );
      } else {
        breadList.value = [{ path: "/", meta: { title: "首页" } }];
      }
    });
    return {
      toggleCollapsed,
      breadList,
      route
    };
  }
});
</script>
<style lang='less' scoped>
// @import url(); 引入公共css类
.header {
  position: fixed;
  width: calc(100% - 250px);
  z-index: 10;
  border-bottom: 1px solid #ccc;
}
.header-dd {
  //   layout-flex(row, space-between, center);
  #flex-box.row-b-c();
  .header-line {
    #flex-box.row-c-c();
    .breadcrumb {
      margin-left: 20px;
    }
  }
}
</style>